import { FormControl } from '@angular/forms';
import {
	PolicyDto,
	PolicyPaymentApprovalStatusEnum,
	TicketPolicyDto,
} from './dto-insurance';
export abstract class AbstractDto {
	hashCode!: number;
}
export abstract class AbstractDynamicDto extends AbstractDto {
	properties!: { [key: string]: string };
}
export class AgentDto extends AbstractDto {
	id?: number;
	createdAt?: Date;
	username?: string;
	password?: string;
	firstName?: string;
	lastName?: string;
	emailAddress?: string;
	msisdn?: string;
	status!: AgentStatusEnum;
	superUser!: boolean;
	roles!: AppRoleDto[];
	properties!: DynamicProperties;
	passwordPolicyErrors?: [];
}
export class AppRoleDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	description!: string;
	permissions!: PermissionDto[];
	agents!: AgentLinkDto[];
}
export class PermissionDto extends AbstractDto {
	group!: RolePermissionGroupEnum;
	permission!: RolePermissionEnum;
	label!: string;
	description?: string;
	selected!: boolean;
}
export class LoginRequestDto {
	username?: string;
	password?: string;
	otp?: string;
	channel?: OtpChannelEnum;
}
export class LoginResponseDto extends AbstractDto {
	success?: boolean;
	message?: string;
	agent?: AgentDto;
	expiresIn?: number;
	jwtToken?: string;
	requiresNewPassword?: boolean;
	passwordPolicyErrors?: string[];
}
export class ForgotPasswordResetResponseDto extends AbstractDto {
	result?: OtpLookupResultEnum;
	message?: string;
}
export class AuthenticationWrapper {
	expiresAt!: number;
	agent!: AgentDto;
	authToken!: string;
	requiresNewPassword?: boolean;
	passwordPolicyErrors?: string[];
}

export class DynamicFormDto extends AbstractDto {
	id?: number;
	templateName!: string;
	elements!: DynamicFormElementDto[];
	entityType!: DynamicEntityTypeEnum;
	subForms!: { [key: string]: DynamicFormDto }; //Key is of type: DynamicEntityTypeEnum
	formControls?: { [id: number]: FormControl };
}
export class DynamicFormElementDto extends AbstractDto {
	id!: number;
	value?: Object | DynamicFormDto[];
	property!: string;
	dependencyId?: number;

	name!: string;
	description!: string;
	sectionName!: string;
	dependencyValue?: string;
	dependencyValueInverted: boolean = false;
	dataType!: DynamicValueDataTypeEnum;
	options?: DynamicFormOptionDto[];
	orderIndex!: number;
	lineNumber?: number;
	icon?: string;
	activeOnCreate!: Boolean;
	activeOnUpdate!: Boolean;
	required!: Boolean;
	errorMessageRequired?: string;
	isUnique!: Boolean;
	hidden: Boolean = false;
	errorMessageUnique?: string;
	regex?: string;
	errorMessageRegex?: string;
	minValue?: number;
	errorMessageMinValue?: string;
	maxValue?: number;
	errorMessageMaxValue?: string;
	subEntityType?: DynamicEntityTypeEnum;
}
export class DynamicFormOptionDto extends AbstractDto {
	value?: string;
	tag?: string;
	label!: string;
	orderIndex!: number;
}
export class DynamicPropertyDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	property!: string;
	name!: string;
	description?: string;
	bulkImportColumnName?: string;
	type!: DynamicTypeEnum;
	dependencyId?: number;
	sectionId!: number;
	orderIndex!: number;
	icon?: string;
	activeOnCreate!: Boolean;
	activeOnUpdate!: Boolean;
	searchable!: Boolean;
	dataType!: DynamicValueDataTypeEnum;
	isUnique!: Boolean;
	minValue?: number;
	maxValue?: number;
	required!: Boolean;
	regex?: string;
	dependencyValue?: string;
	dependencyValueInverted?: boolean;
	options!: DynamicFormOptionDto[];
	errorMessageUnique?: string;
	errorMessageRequired?: string;
	errorMessageRegex?: string;
	errorMessageMinValue?: string;
	errorMessageMaxValue?: string;
	fieldDisabled!: boolean;
	subDynamic?: DynamicEntityDto;
}
export class DynamicEntityDto extends AbstractDto {
	id!: number;
	label!: string;
	description!: string;
	template!: DynamicTemplateDto;
	properties!: DynamicPropertyDto[];
	entityType!: DynamicEntityTypeEnum;
	subEntityTypes!: DynamicEntityTypeEnum[];
}
export class DynamicTemplateDto extends AbstractDto {
	id!: number;
	name!: string;
	description?: string;
	sections!: DynamicTemplateSectionDto[];
}
export class DynamicTemplateSectionDto extends AbstractDto {
	id!: number;
	name!: string;
	description?: string;
}

export class EmployerDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	properties!: DynamicProperties;
	members!: MemberDto[];
	memberCount?: number;
}
export class CategoryDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	properties!: DynamicProperties;
}
export class MemberDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	idNumber!: string;
	name!: string;
	surname!: string;
	msisdn?: string;
	emailAddress?: string;
	dateOfBirth!: Date;
	dateOfDeath?: Date;
	capturedByAgent?: AgentDto;
	dependants!: DependantDto[];
	memberships!: MembershipDto[];
	employer!: EmployerDto;
	policies!: PolicyDto[];
	properties!: DynamicProperties;
}
export class MembershipDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	membershipNumber!: string;
	category!: string;
}
// export class MemberInsurancePolicyDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	member!: MemberDto;
// 	employerPolicy?: EmployerInsurancePolicyDto;
// 	product!: InsuranceProductDto;
// 	productOffer!: InsuranceProductOfferDto;
// 	productOfferOption!: InsuranceProductOfferOptionDto;
// 	policyNumber!: string;
// 	balance!: number;
// 	cost!: number;
// 	paidUntil!: Date;
// 	status!: PolicyStatusEnum;
// 	extensions!: MemberInsurancePolicyExtensionDto[];
// }
// export class MemberInsurancePolicyExtensionDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	extension!: InsuranceProductExtensionDto;
// 	dependant!: DependantDto;
// }
// export class EmployerInsurancePolicyDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	product!: InsuranceProductDto;
// 	employer!: EmployerDto;
// 	productOffer!: InsuranceProductOfferDto;
// 	productOfferOption!: InsuranceProductOfferOptionDto;
// 	policyNumber!: string;
// 	memberCount!: number;
// 	cost!: number;
// 	balance!: number;
// 	paidUntil!: Date;
// 	totalReceived!: number;
// 	totalPaid!: number;
// 	status!: PolicyStatusEnum;
// 	deletedAt!: Date;
// }
// export class MemberEmployerHistoryDto extends AbstractDto {
// 	employer!: EmployerDto;
// 	position!: string;
// 	fromDate!: Date;
// 	toDate?: Date;
// }

export class DependantDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	relationship!: MemberRelationshipEnum;
	relationshipIsClose!: boolean;
	dependantNumber!: number;
	idNumber!: string;
	name!: string;
	surname!: string;
	msisdn!: string;
	emailAddress!: string;
	dateOfBirth!: Date;
	properties!: DynamicProperties;
}

export class DynamicPayloadDto {
	instanceId?: number;
	properties!: DynamicPayloadDto_Property[];
}
export class DynamicPayloadDto_Property {
	propertyId!: number;
	value?:
		| DynamicPayloadDto_PropertyValueSimple
		| DynamicPayloadDto_PropertyValueList
		| DynamicPayloadDto_PropertyValueSubPayload;
}
export class DynamicPayloadDto_PropertyValueSimple {
	dynamicPropertyValueType = 'simple';
	value?: string;
}
export class DynamicPayloadDto_PropertyValueList {
	dynamicPropertyValueType = 'list';
	values!: DynamicPayloadDto_PropertyValueSubPayload[];
}
export class DynamicPayloadDto_PropertyValueSubPayload {
	dynamicPropertyValueType = 'subPayload';
	instanceId?: number;
	properties!: DynamicPayloadDto_Property[];
}

export class WorkflowDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	label!: string;
	description!: string;
	referencePrefix!: string;
	steps!: WorkflowStepDto[];
	availableReadOnlyFields!: WorkflowStepReadOnlyFieldDto[];
	autoAssign!: boolean;
	linkMemberships!: boolean;
	categoryTemplate?: string;
	linkToOtherTicketEnabled!: boolean;
	restrictToPolicies!: boolean;
	ticketMode!: TicketModeEnum;
	slaDurationWarning?: string;
	slaDurationBreach?: string;
	slaDurationEscalation?: string;
}
export class WorkflowStepButtonActionDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflowStepButton?: WorkflowStepButtonDto;
	actionType!: WorkflowActionTypeEnum;
	orderIndex!: number;
	linkedToProduct!: boolean;
	name?: string;
	emailFrom?: string;
	emailTo?: string;
	emailCc?: string;
	emailBcc?: string;
	emailSubject?: string;
	emailBody?: string;
	smsRecipients?: string;
	smsMessage?: string;
	attachments?: FileUploadDto[];
	movementWorkflowStepId?: number;
	movementWorkflowStepStatusId?: number;
	additionalCommentRequired?: boolean;
}
export class WorkflowStepButtonDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	label!: string;
	statusId!: number;
	stepLabel?: string;
	statusLabel?: string;
	dependencyId?: number;
	dependencyLabel?: string;
	dependencyValue?: string;
	orderIndex!: number;

	buttonStyle!: ButtonStyleEnum;
	buttonType!: ButtonTypeEnum;
	icon!: string;
	requiredValidForm!: boolean;
	alignment!: ButtonAlignmentEnum;

	actions!: WorkflowStepButtonActionDto[];
}
export class WorkflowStepDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	description!: string;
	label!: string;
	stepOrder!: number;
	slaDurationWarning!: string;
	slaDurationBreach!: string;
	slaDurationEscalation!: string;
	readOnlyFields!: WorkflowStepReadOnlyFieldDto[];
	sections!: WorkflowStepSectionDto[];
	buttons!: WorkflowStepButtonDto[];
	statuses!: WorkflowStepStatusDto[];
	ticketCount?: number;
	questionnaire!: boolean;
	questionnaireEditable!: boolean;
}
export class WorkflowStepStatusDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	label!: string;
	reportAlias?: string;
	ticketCount?: number;

	slaDurationWarning!: string;
	slaDurationBreach!: string;
	slaDurationEscalation!: string;
	ticketOpenCountWithinSla?: number;
	ticketOpenCountNearingSlaLimit?: number;
	ticketOpenCountOutOfSla?: number;
	ticketAllCountWithinSla?: number;
	ticketAllCountNearingSlaLimit?: number;
	ticketAllCountOutOfSla?: number;
}
export class WorkflowStepSectionDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	label!: string;
	sectionOrder!: number;
	elements!: WorkflowStepSectionElementDto[];
	statusIds!: number[];
}
export class WorkflowStepSectionElementDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	lookupKey?: string;
	valueWhenChecked?: string;
	label!: string;
	description!: string;
	dependencyId?: number;
	orderIndex!: number;
	lineNumber?: number;
	icon?: string;
	dataType!: DynamicValueDataTypeEnum;
	unique!: boolean;
	required!: boolean;
	dependencyValue?: string;
	options!: WorkflowFormOptionDto[];
	regex?: string;
	minValue?: number;
	maxValue?: number;
	hidden?: boolean;
	errorMessageUnique?: string;
	errorMessageRequired?: string;
	errorMessageRegex?: string;
	errorMessageMinValue?: string;
	errorMessageMaxValue?: string;
	flagForDuplicateTicket?: boolean;
	flagForSpecialField?: boolean;
	statusIds!: number[];
}

export class WorkflowStepReadOnlyFieldDto extends AbstractDto {
	dynamicPropertyId!: number;
	group!: string;
	name!: string;
	selected!: boolean;
}
export class WorkflowFormOptionDto extends AbstractDto {
	label!: string;
	value?: string;
	orderIndex!: number;
}

export class TicketUploadPayload {
	fieldProperties!: { [key: number]: string | undefined };
	additionalFiles!: { [key: string]: string | undefined };
	requiredCommunications!: { [key: number]: TicketButtonCommunicationDto };
	additionalCommunications!: TicketButtonCommunicationDto[];
	additionalComment?: string;
	button!: TicketButtonDto;
	note?: string;
	assignToAgentId?: number;
}

export class TicketDto extends AbstractDto {
	id!: number;
	createdAt?: Date;
	workflowId!: number;
	workflowLabel!: string;
	workflowDescription!: string;
	steps!: TicketStepDto[];
	status!: TicketStatusEnum;
	createdByAgent!: AgentDto;
	member!: MemberDto;
	membership?: MembershipDto;
	policy?: PolicyDto;
	dependant!: DependantDto;
	assignedToAgent?: AgentDto;
	currentStepAndStateLabel!: string;
	currentStepId!: number;
	focusCategory?: string;

	slaLevelStatus!: TicketSlaLevelEnum;
	timeUntilNextSlaLevelStatus!: string;
	slaLevelStep!: TicketSlaLevelEnum;
	timeUntilNextSlaLevelStep!: string;
	slaLevelGlobal?: TicketSlaLevelEnum;
	timeUntilNextSlaLevelGlobal?: string;
	slaLevelOverall!: TicketSlaLevelEnum;
	timeUntilNextSlaLevelOverall!: string;

	lastActionedAt!: Date;
	relatedToOtherTicket?: TicketDto;
	hasAccess!: boolean;
	ticketUuid!: string;
	ticketMode?: TicketModeEnum;
	ticketReference!: string;
	operationalNotes!: TicketOperationalNoteDto[];
	policySummary?: TicketPolicyDto;
	filesFromOtherSteps!: TicketAdditionalFileDto[];

	questionnaireTemplate?: TicketStepDto;
	questionnaires!: TicketQuestionnaireDto[];
	questionnaireEditable!: Boolean;
}
export class TicketQuestionnaireDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	lastActionedAt!: Date;
	name!: string;
	step!: TicketStepDto;
	progress: number = 0;
}

export class TicketOperationalNoteDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	createdByAgent?: AgentDto;
	note!: string;
}
export class TicketStepDto extends AbstractDto {
	id!: number;
	label!: string;
	description!: string;
	order!: number;
	isCurrentState!: boolean;
	stateLabel!: string;
	completed!: boolean;
	details!: TicketDetailDto[];
	buttons!: TicketButtonDto[];
	sections!: TicketSectionDto[];
	additionalFiles!: TicketAdditionalFileDto[];
	placeholders!: CommunicationPlaceholders;
	availableAttachments!: { [key: number]: FileUploadDto };
	availableAttachmentsAdditional!: { [key: number]: FileUploadDto };
}

export class TicketAdditionalFileDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	addedByAgent!: AgentDto;
	addedStepId!: number;
	addedStepLabel!: string;
	addedStateId!: number;
	addedStateLabel!: string;
	uploadedByAgent?: AgentDto;
	uploadedAt?: Date;
	uploadedStepId?: number;
	uploadedStepLabel?: string;
	uploadedStateId?: number;
	uploadedStateLabel?: string;
	label!: string;
	uuid?: string;
	isReplaced!: Boolean;
	canPreview?: boolean;
	canDownload?: boolean;
}

export class TicketDetailDto extends AbstractDto {
	id!: number;
	groupLabel!: string;
	label!: string;
	dataType!: DynamicValueDataTypeEnum;
	value?: string;
}
export class TicketButtonDto extends AbstractDto {
	id!: number;
	label!: string;
	icon!: string;
	order!: number;
	style!: ButtonStyleEnum;
	type!: ButtonTypeEnum;
	alignment!: ButtonAlignmentEnum;
	requiredValidForm!: boolean;

	statusId?: number;
	statusLabel?: string;
	requiredCommunications!: TicketButtonCommunicationDto[];
	additionalCommunications?: TicketButtonCommunicationDto[];
	onClickSubmitForm!: boolean;
	onClickGotoTicketList!: boolean;
	onClickComposeAdditionalCommunication!: boolean;
	onClickCaptureAdditionalComment!: boolean;
	isAdditionalCommentRequired!: boolean;
}
export class TicketSectionDto extends AbstractDto {
	id!: number;
	label!: string;
	order!: number;
	elements!: TicketElementDto[];
}
export class TicketElementDto extends AbstractDto {
	id!: number;
	label!: string;
	description!: string;
	dependencyId?: number;
	dependencyValue?: string;
	order!: number;
	lineNumber?: number;
	icon?: string;
	dataType!: DynamicValueDataTypeEnum;
	isUnique!: boolean;
	hidden!: boolean;
	minValue?: number;
	maxValue?: number;
	required!: boolean;
	regex?: string;
	options!: DynamicFormOptionDto[];
	errorMessageUnique?: string;
	errorMessageRequired?: string;
	errorMessageRegex?: string;
	errorMessageMinValue?: string;
	errorMessageMaxValue?: string;
	value?: string;
}

export class TicketButtonCommunicationDto extends AbstractDto {
	id!: number;
	createdAt?: Date;
	actionType!: WorkflowActionTypeEnum;
	type!: CommunicationTypeEnum;
	name?: string;
	emailFrom?: string;
	emailTo?: string;
	emailCc?: string;
	emailBcc?: string;
	emailSubject?: string;
	emailBody?: string;
	smsMsisdn?: string;
	smsMessage?: string;
	attachments?: FileUploadDto[];
	triggeredByAgent?: AgentDto;
	status!: NotificationStatusEnum;
	errorMessage?: string;
}

export class TicketAdditionalCommentDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflowStep!: WorkflowStepDto;
	workflowStepStatus!: WorkflowStepStatusDto;
	agent!: AgentDto;
	comment!: string;
}
export class TicketMovementDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	triggeredByAgent!: AgentDto;
	workflowStep!: WorkflowStepDto;
	workflowStepButton?: WorkflowStepButtonDto;
	workflowStepStatus!: WorkflowStepStatusDto;
	assignedToAgent?: AgentDto;
	completed!: boolean;
}
export class TicketHistoryDto extends AbstractDto {
	ticket!: TicketDto;
	movements!: TicketMovementDto[];
	communications!: TicketButtonCommunicationDto[];
	additionalComments!: TicketAdditionalCommentDto[];
	additionalFiles!: TicketAdditionalFileDto[];
	operationalNotes!: TicketOperationalNoteDto[];
	fields!: TicketHistoryCapturedFieldDto[];
}
export class TicketHistoryCapturedFieldDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	agentFullName?: string;
	workflowStepLabel!: string;
	workflowSectionLabel!: string;
	inputLabel!: string;
	inputDescription!: string;
	inputValue?: string;
	inputValueObject?: any;
	dataType!: DynamicValueDataTypeEnum;
	canPreview?: boolean;
	canDownload?: boolean;
}

export class MemberSearchResultListDto extends AbstractDto {
	searchPhrase!: string;
	results!: MemberSearchResultDto[];
	tooOpen!: boolean;
}
export class MemberSearchResultDto extends AbstractDto {
	matchOn!: string;
	member!: MemberDto;
}
export class ResultListDto<T> extends AbstractDto {
	list!: T[];
	totalItems!: number;
	pageIndex!: number;
	pageSize!: number;
}

export class FileUploadDto extends AbstractDto {
	refId?: number;
	uuid!: string;
	fileName!: string;
	name!: string;
	size!: number;
	type!: string;
	selected?: boolean;
}

export class WorkflowRoleDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflow!: WorkflowDto;
	name!: string;
	description!: string;
	active!: boolean;
	statuses!: WorkflowRoleStepStatusDto[];
	agents!: AgentLinkDto[];
}
export class WorkflowRoleStepStatusDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflowStep!: WorkflowStepDto;
	workflowStepStatus!: WorkflowStepStatusDto;
	type!: WorkflowRoleTypeEnum;
}

export class AgentLinkDto extends AbstractDto {
	agentId!: number;
	agentName!: string;
	agentSurname!: string;
	linked!: boolean;
}

export class BulkUploadSettingDto extends AbstractDto {
	required!: boolean;
	name!: string;
	label!: string;
	description!: string;
	fileType!: string;
}
export class BulkUploadDto extends AbstractDto {
	id?: number;
	createdAt?: Date;
	type?: string;
	agent?: AgentDto;
	status?: BulkUploadStatusEnum;
	files?: BulkUploadFileDto[];
	insertCount?: number;
	updateCount?: number;
	invalidCount?: number;
	failedCount?: number;
}
export class BulkUploadFileDto extends AbstractDto {
	id?: number;
	name!: string;
	agent!: AgentDto;
	status!: BulkUploadStatusEnum;
	uploadedAt!: Date;
	startedAt?: Date;
	completedAt?: Date;
	file!: FileUploadDto;
	lineCount!: number;
	validCount!: number;
	updateCount!: number;
	insertCount!: number;
	failedCount!: number;
}

export class BulkUploadFileLineDto extends AbstractDto {
	sheetName!: string;
	lineNumber!: number;
	status!: BulkUploadLineStatusEnum;
	columns!: BulkUploadFileCellDto[];
}
export class BulkUploadFileCellDto extends AbstractDto {
	name?: string;
	value?: string;
	propertyId?: number;
	valid!: boolean;
	message?: string;
}

export class Duration {
	years: number = 0;
	months: number = 0;
	days: number = 0;
	hours: number = 0;
	minutes: number = 0;
	seconds: number = 0;
}
export class TicketBundleDto extends AbstractDto {
	agents!: AgentDto[];
	assignableAgents!: AgentDto[];
	workflows!: WorkflowDto[];
	ticketsToFocusOn!: ResultListDto<TicketDto>;
}
export class TicketReportDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name?: string;
	description?: string;
	isSummary!: boolean;
	sqlQuery?: string;
	workflow!: WorkflowDto;
}
export class TicketReportPreviewDto extends AbstractDto {
	columnTitles!: String[];
	rows!: TicketReportPreviewRowDto[];
}
export class TicketReportPreviewRowDto extends AbstractDto {
	cells!: TicketReportPreviewCellDto[];
}
export class TicketReportPreviewCellDto extends AbstractDto {
	value!: string | number;
	alignment!: TicketReportCellAlignmentEnum;
}

export class NotificationBulkDto extends AbstractDto {
	id?: number;
	createdAt?: Date;
	createdByAgent?: AgentDto;
	status?: BulkNotificationStatusEnum;
	channel?: CommunicationTypeEnum;
	subject?: String;
	body?: String;
	nextRunDate?: Date;
	deliveryReport?: Boolean;
}

export class NotificationBulkFilterDto extends AbstractDto {
	id?: number;
	notificationBulk?: NotificationBulkDto;
	propertyId!: number;
	propertyName!: string;
	operator!: FilterOperatorEnum;
	dataType!: DynamicValueDataTypeEnum;
	value!: any;
}

export class NotificationBulkTriggerDto extends AbstractDto {
	id?: number;
	notificationBulk?: NotificationBulkDto;
	triggerName!: string;
	triggerDescription!: string;
	triggerType!: CommunicationTriggerTypeEnum;
	frequency!: CommunicationFrequencyTypeEnum;
	reminderBefore!: CommunicationReminderBeforeEnum;
	reminderBeforeValue!: number;
	triggerTime!: string | undefined;
	description?: string;
}

export class NotificationBulkLogDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	notificationBulk!: NotificationBulkDto;
	channel!: CommunicationTypeEnum;
	subject!: String;
	body!: String;
	triggerType!: CommunicationTriggerTypeEnum;
	runDate!: Date;
	nextRunDate!: Date;
	eligibleMemberCount?: number;
}

export class BulkNotificationDto extends AbstractDto {
	bulk?: NotificationBulkDto;
	trigger?: NotificationBulkTriggerDto;
	filters?: NotificationBulkFilterDto[];
	filterCount?: number;
	expanded?: boolean;
	attachments?: FileUploadDto[];
}
export class AiMessageDto extends AbstractDto {
	when!: Date;
	duration!: number;
	direction?: 'Sent' | 'Received';
	message!: string;
	messageHtml!: string;
}

export class NotificationBulkReportDto extends AbstractDto {
	name!: string;
	agent!: AgentDto;
	createdAt!: Date;
	sentAt!: Date;
	channel!: CommunicationTypeEnum;
	sendDuration!: number;
	metrics!: Record<BulkNotificationMetricEnum, string>;
	attachments!: FileUploadDto[];
	trigger!: NotificationBulkTriggerDto;
	filters!: NotificationBulkFilterDto[];
	subject!: string;
	body!: string;
}
export class HierarchyDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	description!: string;
	subHierarchies!: HierarchyDto[];
}

export enum BulkNotificationMetricEnum {
	Sent = 'Sent',
	Accepted = 'Accepted',
	AdminBounce = 'AdminBounce',
	BlockBounce = 'BlockBounce',
	Bounce = 'Bounce',
	Clicked = 'Clicked',
	Delayed = 'Delayed',
	DelayedFirst = 'DelayedFirst',
	Delivered = 'Delivered',
	DeliveredFirst = 'DeliveredFirst',
	DeliveredSubsequent = 'DeliveredSubsequent',
	GenerationFailed = 'GenerationFailed',
	GenerationRejection = 'GenerationRejection',
	HardBounce = 'HardBounce',
	InbandBounce = 'InbandBounce',
	InitialRendered = 'InitialRendered',
	Injected = 'Injected',
	NonPrefetchedInitialRendered = 'NonPrefetchedInitialRendered',
	NonPrefetchedRendered = 'NonPrefetchedRendered',
	NonPrefetchedUniqueConfirmedOpened = 'NonPrefetchedUniqueConfirmedOpened',
	NonPrefetchedUniqueInitialRendered = 'NonPrefetchedUniqueInitialRendered',
	NonPrefetchedUniqueRendered = 'NonPrefetchedUniqueRendered',
	OutOfBandBounce = 'OutOfBandBounce',
	PolicyRejection = 'PolicyRejection',
	Rejected = 'Rejected',
	Rendered = 'Rendered',
	SoftBounce = 'SoftBounce',
	SpamComplaint = 'SpamComplaint',
	Targeted = 'Targeted',
	UndeterminedBounce = 'UndeterminedBounce',
	UniqueClicked = 'UniqueClicked',
	UniqueConfirmedOpened = 'UniqueConfirmedOpened',
	UniqueInitialRendered = 'UniqueInitialRendered',
	UniqueRendered = 'UniqueRendered',
	Unsubscribe = 'Unsubscribe',
	TotalDeliveryTimeFirst = 'TotalDeliveryTimeFirst',
	TotalDeliveryTimeSubsequent = 'TotalDeliveryTimeSubsequent',
	TotalMsgVolume = 'TotalMsgVolume',
	AcceptedRate = 'AcceptedRate',
	AdminBounceRate = 'AdminBounceRate',
	AvgDeliveryTimeFirst = 'AvgDeliveryTimeFirst',
	AvgDeliveryTimeSubsequent = 'AvgDeliveryTimeSubsequent',
	AvgMsgSize = 'AvgMsgSize',
	BlockBounceRate = 'BlockBounceRate',
	BounceRate = 'BounceRate',
	ClickThroughRate = 'ClickThroughRate',
	CountInbox = 'CountInbox',
	CountSpam = 'CountSpam',
	DelayedRate = 'DelayedRate',
	HardBounceRate = 'HardBounceRate',
	OpenRate = 'OpenRate',
	RejectedRate = 'RejectedRate',
	SoftBounceRate = 'SoftBounceRate',
	SpamComplaintRate = 'SpamComplaintRate',
	UndeterminedBounceRate = 'UndeterminedBounceRate',
	UnsubscribeRate = 'UnsubscribeRate',
}

export class NotificationBulkEventsDto {
	name!: string;
	surname!: string;
	to!: string;

	accepted!: number;
	delivery!: number;
	open!: number;
	click!: number;
	bounce!: number;
	spamComplaint!: number;
	policyRejection!: number;

	acceptedAt!: Date;
	deliveryAt!: Date;
	openedAt!: Date[];
	clickedAt!: Date[];
	bouncedAt!: Date;
	spamComplaintAt!: Date;
	policyRejectionAt!: Date;
}

export enum FilterOperatorEnum {
	Equal = 'Equal',
	LessThan = 'LessThan',
	GreaterThan = 'GreaterThan',
	LessThanEqual = 'LessThanEqual',
	GreaterThanEqual = 'GreaterThanEqual',
}

// export class InsuranceProductDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	name!: string;
// 	descriptionOfBenefits!: string;
// 	descriptionOfBenefitsPayableWhen!: string;
// 	descriptionOfBenefitsPayableTo!: string;
// 	insuranceUnderwriter?: InsuranceCommissionRecipientDto;
// 	insuranceBinder?: InsuranceCommissionRecipientDto;
// 	insuranceServiceProvider?: InsuranceCommissionRecipientDto;
// 	insurancePolicyGroup?: InsuranceCommissionRecipientDto;
// 	insuranceIntermediaryAdministrator?: InsuranceCommissionRecipientDto;
// 	insuranceIntermediaryGroup?: InsuranceCommissionRecipientDto;
// 	compulsory!: boolean;
// 	enabled!: boolean;
// 	offers!: InsuranceProductOfferDto[];
// 	extensions!: InsuranceProductExtensionDto[];
// }
// export class InsuranceCommissionRecipientDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	name!: string;
// 	properties!: DynamicProperties;
// }
// export class ProductCommissionRecipientMapDto extends AbstractDto {
// 	underwriters!: InsuranceCommissionRecipientDto[];
// 	binders!: InsuranceCommissionRecipientDto[];
// 	serviceProviders!: InsuranceCommissionRecipientDto[];
// 	policyGroups!: InsuranceCommissionRecipientDto[];
// 	intermediaryAdministrators!: InsuranceCommissionRecipientDto[];
// 	intermediaryGroups!: InsuranceCommissionRecipientDto[];
// }
// export class InsuranceProductWithPolicyDataDto extends AbstractDto {
// 	product!: InsuranceProductDto;
// 	policyCount!: number;
// 	memberCount!: number;
// 	premiumAmount!: number;
// }

// export class InsuranceProductOfferDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	name!: string;
// 	description!: string;
// 	options!: InsuranceProductOfferOptionDto[];
// 	enabled!: boolean;
// }
// export class InsuranceProductOfferOptionDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	name!: string;
// 	description!: string;
// 	enabled!: boolean;
// 	maxSpouses!: number;
// 	maxDependants!: number;
// 	maxExtended!: number;
// 	maxMembers!: number;
// 	maxWeeksOfStillBorn!: number;
// 	waitingPeriodDeathAccidental!: string;
// 	waitingPeriodDeathSuicide!: string;
// 	waitingPeriodDeathNatural!: string;
// 	waivingOfWaitingPeriodAllowed!: boolean;
// 	allowTransferOfMembership!: boolean;
// 	allowIncreaseOfBenefits!: boolean;
// 	contractPeriod!: InsuranceProductContractPeriodEnum;
// 	benefitAmount!: number;
// 	benefitPercentage!: number;
// 	premiumAmount!: number;
// 	premiumPercentage!: number;
// 	feeAmount!: number;
// 	feePercentage!: number;
// 	filters!: InsuranceProductOfferOptionFilterDto[];
// 	addOns!: InsuranceProductOfferOptionAddOnDto[];
// 	benefitSplits!: InsuranceProductOfferOptionBenefitSplitDto[];

// 	binderPremiumSplit!: boolean;
// 	binderPremiumSplitName?: string;
// 	binderPremiumSplitAmount?: number;
// 	binderPremiumSplitPercentage?: number;
// 	binderPremiumSplitCalculated?: number;
// 	underwriterPremiumSplit!: boolean;
// 	underwriterPremiumSplitName?: string;
// 	underwriterPremiumSplitAmount?: number;
// 	underwriterPremiumSplitPercentage?: number;
// 	underwriterPremiumSplitCalculated?: number;
// 	serviceProviderPremiumSplit!: boolean;
// 	serviceProviderPremiumSplitName?: string;
// 	serviceProviderPremiumSplitAmount?: number;
// 	serviceProviderPremiumSplitPercentage?: number;
// 	serviceProviderPremiumSplitCalculated?: number;
// 	salesPersonPremiumSplitAmount?: number;
// 	salesPersonPremiumSplitPercentage?: number;
// 	salesPersonPremiumSplitCalculated?: number;
// 	policyGroupPremiumSplit!: boolean;
// 	policyGroupPremiumSplitName?: string;
// 	policyGroupPremiumSplitAmount?: number;
// 	policyGroupPremiumSplitPercentage?: number;
// 	policyGroupPremiumSplitCalculated?: number;
// 	intermediaryAdministratorPremiumSplit!: boolean;
// 	intermediaryAdministratorPremiumSplitName?: string;
// 	intermediaryAdministratorPremiumSplitAmount?: number;
// 	intermediaryAdministratorPremiumSplitPercentage?: number;
// 	intermediaryAdministratorPremiumSplitCalculated?: number;
// 	intermediaryGroupPremiumSplit!: boolean;
// 	intermediaryGroupPremiumSplitName?: string;
// 	intermediaryGroupPremiumSplitAmount?: number;
// 	intermediaryGroupPremiumSplitPercentage?: number;
// 	intermediaryGroupPremiumSplitCalculated?: number;

// 	calculatedPremium?: number;
// 	calculatedFees?: number;
// 	calculatedAddOn?: number;
// 	calculatedGrossRiskPremium?: number;
// 	calculatedNetRiskPremium?: number;
// }
// export class InsuranceProductExtensionDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	name!: string;
// 	description!: string;
// 	benefitAmount!: number;
// 	benefitPercentage!: number;
// 	premiumAmount!: number;
// 	premiumPercentage!: number;
// 	feeAmount!: number;
// 	feePercentage!: number;
// 	enabled!: boolean;
// 	filters!: InsuranceProductOfferOptionFilterDto[];
// 	calculatedPremium?: number;
// 	calculatedFees?: number;
// 	calculatedAddOn?: number;
// 	calculatedGrossRiskPremium?: number;
// 	calculatedNetRiskPremium?: number;

// 	binderPremiumSplit!: boolean;
// 	binderPremiumSplitName?: string;
// 	binderPremiumSplitAmount?: number;
// 	binderPremiumSplitPercentage?: number;
// 	binderPremiumSplitCalculated?: number;
// 	underwriterPremiumSplit!: boolean;
// 	underwriterPremiumSplitName?: string;
// 	underwriterPremiumSplitAmount?: number;
// 	underwriterPremiumSplitPercentage?: number;
// 	underwriterPremiumSplitCalculated?: number;
// 	serviceProviderPremiumSplit!: boolean;
// 	serviceProviderPremiumSplitName?: string;
// 	serviceProviderPremiumSplitAmount?: number;
// 	serviceProviderPremiumSplitPercentage?: number;
// 	serviceProviderPremiumSplitCalculated?: number;
// 	salesPersonPremiumSplitAmount?: number;
// 	salesPersonPremiumSplitPercentage?: number;
// 	salesPersonPremiumSplitCalculated?: number;
// 	policyGroupPremiumSplit!: boolean;
// 	policyGroupPremiumSplitName?: string;
// 	policyGroupPremiumSplitAmount?: number;
// 	policyGroupPremiumSplitPercentage?: number;
// 	policyGroupPremiumSplitCalculated?: number;
// 	intermediaryAdministratorPremiumSplit!: boolean;
// 	intermediaryAdministratorPremiumSplitName?: string;
// 	intermediaryAdministratorPremiumSplitAmount?: number;
// 	intermediaryAdministratorPremiumSplitPercentage?: number;
// 	intermediaryAdministratorPremiumSplitCalculated?: number;
// 	intermediaryGroupPremiumSplit!: boolean;
// 	intermediaryGroupPremiumSplitName?: string;
// 	intermediaryGroupPremiumSplitAmount?: number;
// 	intermediaryGroupPremiumSplitPercentage?: number;
// 	intermediaryGroupPremiumSplitCalculated?: number;
// }
// export class InsuranceProductOfferOptionAddOnDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	name!: string;
// 	description!: string;
// 	enabled!: boolean;
// 	benefitAmount!: number;
// 	benefitPercentage!: number;
// 	premiumAmount!: number;
// 	premiumPercentage!: number;
// 	feeAmount!: number;
// 	feePercentage!: number;
// }

// export class InsuranceProductOfferOptionFilterDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	name!: string;
// 	filterDomain!: InsuranceProductDomainEnum;
// 	filterType!: InsuranceProductFilterTypeEnum;
// 	filterValue!: string;
// }

// export class InsuranceProductOfferOptionBenefitSplitDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	domain!: InsuranceProductDomainEnum;
// 	fromAge!: number;
// 	toAge!: number;
// 	benefitAmount!: number;
// 	benefitPercentage!: number;
// 	calculatedBenefit!: number;
// 	enabled!: boolean;
// }
export class BankDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
}
export class BankAccountDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	bank!: BankDto;
	// member?: MemberDto;
	// employer?: EmployerDto;
	accountNumber!: string;
	accountName!: string;
	deactivatedAt!: Date;
	transactions!: BankAccountTransactionDto[];
}
export class BankAccountTransactionDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	reference!: string;
	amount!: number;
	type!: LedgerTypeEnum;
}
export class LedgerDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	bankAccountFrom!: BankAccountDto;
	bankAccountTo!: BankAccountDto;
	amount!: number;
	transactionReference!: string;
}
// export class InsurancePolicyLedgerDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	ledger?: LedgerDto;
// 	policyCount!: number;
// 	amount!: number;
// 	balanceBefore!: number;
// 	balanceAfter!: number;
// 	type!: LedgerTypeEnum;
// }
// export class InsurancePolicyStatementDto extends AbstractDto {
// 	previousMonthClosing?: InsurancePolicyStatementLineItemDto;
// 	lineItemGroups!: InsurancePolicyStatementLineItemGroupDto[];
// 	amountVat!: number;
// 	amountExcl!: number;
// 	amountIncl!: number;
// 	balance!: number;
// }

// export class InsurancePolicyStatementLineItemGroupDto extends AbstractDto {
// 	date!: Date;
// 	lineItems!: InsurancePolicyStatementLineItemDto[];
// }

// export class InsurancePolicyStatementLineItemDto extends AbstractDto {
// 	detail!: string;
// 	amountVat!: number;
// 	amountExcl!: number;
// 	amountIncl!: number;
// 	balance!: number;
// 	isDebit!: boolean;
// }

export class MemberSearchDto {
	idNumber?: string;
	employerId?: number;
	name?: string;
	surname?: string;
	msisdn?: string;
	emailAddress?: string;
	membershipNumber?: string;
	pageIndex?: number;
	pageSize?: number;
}

export class ProductSearchDto {
	productName?: string;
	productType?: string;
	policyGroup?: string;
	underwriter?: string;
	employer?: string;
	productOfferName?: string;
	memberId?: number;
	pageIndex?: number;
	pageSize?: number;
}

// export class InsuranceDashboardDto extends AbstractDto {
// 	previousCountPoliciesIndividual!: number;
// 	previousCountPoliciesEmployer!: number;
// 	previousCountPoliciesMembers!: number;
// 	previousCountPremiumDebited!: number;
// 	previousCountPremiumCredited!: number;
// 	previousPremiumAmountDebited!: number;
// 	previousPremiumAmountCredited!: number;

// 	currentCountPoliciesIndividual!: number;
// 	currentCountPoliciesEmployer!: number;
// 	currentCountPoliciesMembers!: number;
// 	currentCountPremiumDebited!: number;
// 	currentCountPremiumCredited!: number;
// 	currentPremiumAmountDebited!: number;
// 	currentPremiumAmountCredited!: number;

// 	countProducts!: number;

// 	topProducts!: InsuranceDashboardProductDto[];
// 	topPolicies!: InsuranceDashboardPolicyDto[];
// }
// export class InsuranceDashboardProductDto extends AbstractDto {
// 	product!: InsuranceProductDto;
// 	policyCount!: number;
// 	memberCount!: number;
// 	premiumAmount!: number;
// }

// export class InsuranceDashboardPolicyDto extends AbstractDto {
// 	policy!: MemberInsurancePolicyDto | EmployerInsurancePolicyDto;
// 	type!: string;
// 	memberCount!: number;
// 	premiumAmount!: number;
// 	outstandingAmount!: number;
// 	lastPaidAt?: Date;
// }
export class EmployerPolicyFormDto {
	employerId!: number;
	optionId!: number;
	members!: MemberPolicyFormDto[];
}
export class MemberPolicyFormDto {
	memberId!: number;
	optionId!: number;
	extensions!: MemberPolicyExtensionFormDto[];
}
export class MemberPolicyExtensionFormDto {
	dependantId!: number;
	extensionId!: number;
}

export class DashboardDto {
	id!: number;
	syncedAt!: Date;
	dashboardId!: number;
	dashboardTitle!: string;
	dashboardClientTag!: string;
	dashboardEmbeddedId!: string;
	favourite!: boolean;
	viewed!: number;
	status!: AnalyticDashboardStatusEnum;
}

export class DashboardRequestDto {
	dashboardEmbeddedId!: string;
	agentId?: number;
	from?: Date;
	to?: Date;
}
export class DashboardResponseDto {
	guestToken!: string;
}

export class InsuranceGenericEntityDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	properties!: DynamicProperties;
}

export class ColumnDefinitionDto extends AbstractDto {
	type!: string;
	required!: boolean;
	format!: string;
	description!: string;
	header!: string;
}
export class Icd10CodeDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	chapterNumber!: string;
	chapterDescription!: string;
	groupCode!: string;
	groupDescription!: string;
	icd_10_3_code!: string;
	icd_10_3_code_desc!: string;
	icd_10_code!: string;
	whoFullDescription!: string;
	valid_icd_10_clinical_use!: boolean;
	valid_icd_10_primary!: boolean;
	valid_icd_10_asterisk!: boolean;
	valid_icd_10_dagger!: boolean;
	valid_icd_10_sequelae!: boolean;
	ageRange?: string;
	gender?: string;
	status?: string;
	whoStartDate?: Date;
	whoEndDate?: Date;
	whoRevisionHistory?: string;
	saStartDate?: Date;
	saEndDate?: Date;
	saRevisionHistory?: string;
	comment?: string;
}
// export class InsuranceBankDepositUploadDto extends AbstractDto{
// 	id!: number;
// 	createdAt!: Date;
// 	uploadedAt!: Date;
// 	fileUuid!: string;
// 	agent!: AgentDto;
// 	processStartedAt?: Date;
// 	processCompletedAt?: Date;
// 	countOfRecords?: number;
// 	countOfSuccessfulRecords?: number;
// 	countOfFailedRecords?: number;
// 	countOfInvalidRecords?: number;
// 	amount?: number;
// 	entries!: InsuranceBankDepositUploadEntryDto[];
// }
// export class InsuranceBankDepositUploadEntryDto extends AbstractDto {
// 	id!: number;
// 	createdAt!: Date;
// 	ledger?: LedgerDto;
// 	lineNumber!: number;
// 	depositedAt?: Date;
// 	fromAccountNumber?: string;
// 	toAccountNumber?: string;
// 	amount?: number;
// 	reference?: string;
// 	processStartedAt?: Date;
// 	processCompletedAt?: Date;
// 	valid!: boolean;
// 	successful?: boolean;
// 	failureReason?: string;
// }

export class DashboardV2Dto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	description!: string;
	agent!: AgentDto;
	main!: boolean;
	enabled!: boolean;
	placements!: DashboardV2ComponentPlacementDto[];
}
export class DashboardV2ComponentDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	description!: string;
	componentType!: string;
	columnCanDrillDown!: boolean;
	drillDownName!: string;
	query!: string;
	enabled!: boolean;
}
export class DashboardV2ComponentPlacementDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	dashboardComponent!: DashboardV2ComponentDto;
	breakpoint!: ScreenGridBreakpointEnum;
	xStart!: number;
	xEnd!: number;
	yStart!: number;
	yEnd!: number;
	enabled!: boolean;
}

export class DashboardV2FilterDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: string;
	label!: string;
	required!: boolean;
	query!: string;
}

export class TicketInvoiceDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	workflow!: WorkflowDto;
	recipientDynamicGenetic!: InsuranceGenericEntityDto;
	recipientMember!: MemberDto;
	approvalAgent!: AgentDto;
	approvalStatus!: PolicyPaymentApprovalStatusEnum;
	approvalStatusMessage!: String;
	paymentAt!: Date;
	deletedAt!: Date;
	lines!: TicketInvoiceLineDto[];
	approvals!: TicketInvoiceApprovalDto[];
}
export class TicketInvoiceApprovalDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	invoiceAmount!: number;
	assignedToAgent!: AgentDto;
	approvalAgent!: AgentDto;
	status!: PolicyPaymentApprovalStatusEnum;
	statusMessage!: String;
	decisionAt!: Date;
	deletedAt!: Date;
}
export class TicketInvoiceApprovalSettingAgentDto {
	agentId!: number;
	agentName!: String;
	allowedToApprove!: Boolean;
}
export class TicketInvoiceApprovalSettingDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	paymentThreshold!: number;
	agents!: TicketInvoiceApprovalSettingAgentDto[];
	allowedAgentIds!: number[];
}
export class TicketInvoiceLineDto extends AbstractDto {
	id!: number;
	createdAt!: Date;
	name!: String;
	description!: String;
	cost!: number;
	amount!: number;
	deletedAt!: Date;
}
export interface ServiceProviderDto {
	id: number;
	name: string;
}

export type AnalyticDashboardStatusEnum = 'Active' | 'Disabled';

export type CommunicationReminderBeforeEnum = 'Day' | 'Week' | 'Month';
export type CommunicationFrequencyTypeEnum =
	| 'FirstDayOfMonth'
	| 'FirstWorkingDayOfMonth'
	| 'LastDayOfMonth'
	| 'LastWorkingDayOfMonth'
	| 'Daily'
	| 'Weekly'
	| 'Fortnight'
	| 'Monthly'
	| 'Quarterly'
	| 'BiAnnually'
	| 'Annually';
export type CommunicationTriggerTypeEnum =
	| 'OnceOff'
	| 'DateOfBirth'
	| 'PolicyRenewalReminder'
	| 'Recurring';
export type BulkNotificationStatusEnum = 'Pending' | 'Disabled' | 'Active';

export type CommunicationPlaceholders = { [key: string]: string };
export type DynamicProperties = { [key: string]: string };
export type RolePermissionEnum =
	| 'MemberAdd'
	| 'MemberEdit'
	| 'MemberView'
	| 'MemberSearch'
	| 'MembersBulkImport'
	| 'Ticket'
	| 'TicketAdmin'
	| 'TicketAssigner'
	| 'TicketViewOtherAgentsTickets'
	| 'TicketReportList'
	| 'TicketReportRun'
	| 'TicketReportAddEdit'
	| 'CommunicationSend'
	| 'CommunicationScheduledAutomated'
	| 'CommunicationLog'
	| 'AgentAdd'
	| 'AgentEdit'
	| 'AgentView'
	| 'AgentList'
	| 'EntityView'
	| 'EntityEdit'
	| 'EntityList'
	| 'EntityAdd'
	| 'DynamicPropertyEdit'
	| 'DynamicPropertyView'
	| 'WorkflowAdd'
	| 'WorkflowView'
	| 'WorkflowEdit'
	| 'WorkflowManageRoles'
	| 'WorkflowClone'
	| 'RoleAdd'
	| 'RoleEdit'
	| 'RoleView'
	| 'RoleList'
	| 'PermissionManage'
	| 'BankDepositCreate'
	| 'BankDepositList'
	| 'BankDepositView'
	| 'PolicyBenefitPaymentApprovalViewSettings'
	| 'PolicyBenefitPaymentApprovalUpdateSettings'
	| 'PolicyBenefitPaymentApprovalViewPendingPayments'
	| 'PolicyBenefitPaymentApprovalApprovePayments'
	| 'PolicyView'
	| 'PolicyCreate'
	| 'PolicyUpdate'
	| 'PolicySearch'
	| 'ProductView'
	| 'ProductCreate'
	| 'ProductUpdate'
	| 'ProductPolicyList'
	| 'ProductScheduleView'
	| 'ProductScheduleUpload'
	| 'ProductDepositView'
	| 'BulkUploadView'
	| 'BulkUploadList'
	| 'BulkUploadCreate'
	| 'NotificationEmailSignatureList'
	| 'NotificationEmailSignatureCreate'
	| 'NotificationEmailSignatureUpdate'
	| 'NotificationEmailSignatureView'
	| 'VerificationLiveStatus';
export type RolePermissionGroupEnum =
	| 'Member'
	| 'Agent'
	| 'Ticket'
	| 'Entity'
	| 'Communication'
	| 'Configuration'
	| 'BankDeposit'
	| 'Policy'
	| 'Product'
	| 'BulkUpload'
	| 'Verification'
	| 'NotificationTemplate';

export type AgentStatusEnum = 'Active' | 'Blocked' | 'Suspended';
export type DynamicValueDataTypeEnum =
	| 'Text'
	| 'TextArea'
	| 'Boolean'
	| 'DropDownSingle'
	| 'Number'
	| 'PastDate'
	| 'FutureDate'
	| 'Date'
	| 'Time'
	| 'PastDateTime'
	| 'FutureDateTime'
	| 'File'
	| 'Password'
	| 'Email'
	| 'Msisdn'
	| 'SetOfRecords'
	| 'SelectFromRecords'
	| 'RequiredCheckbox'
	| 'Hierarchy'
	| 'DependantList'
	| 'MemberAndDependantList'
	| 'CheckboxWithStaticValue'
	| 'IdNumberOfLivingPerson'
	| 'IdNumberOfDeceasedPerson'
	| 'ICD10'
	| 'ServiceProviderID';
export type DynamicTypeEnum = 'Dynamic' | 'Field';
export type OtpLookupResultEnum =
	| 'Valid'
	| 'Invalid'
	| 'Expired'
	| 'MaxAttemptsReached'
	| 'AlreadyUsed';
export type MemberRelationshipEnum =
	| 'Spouse'
	| 'Child'
	| 'ChildUnborn'
	| 'ChildStudent'
	| 'ChildDisabled'
	| 'Parent'
	| 'ParentInLaw'
	| 'Extended'
	| 'All'
	| 'Other';
export type DynamicEntityTypeEnum =
	| 'AgentAdmin'
	| 'AgentFao'
	| 'AgentUnderwriter'
	| 'AgentSalesPerson'
	| 'Member'
	| 'Dependant'
	| 'Category'
	| 'Membership'
	| 'Employer'
	| 'InsuranceUnderwriter'
	| 'InsuranceBinder'
	| 'InsuranceServiceProvider'
	| 'InsurancePolicyGroup'
	| 'InsuranceIntermediaryAdministrator'
	| 'InsuranceIntermediaryGroup'
	| 'InsuranceSalesPerson'
	| 'Bank'
	| 'BankAccount';
export type WorkflowActionTypeEnum =
	| 'SplitTicketGroup'
	| 'RequiredCommunication'
	| 'AdditionalCommunication'
	| 'Movement'
	| 'CancelTicket'
	| 'CloseTicket'
	| 'CancelForm'
	| 'SaveForm'
	| 'AdditionalComment'
	| 'ProductValidate'
	| 'ProductScheduleBenefitPayment'
	| 'ProductApprovalQueue'
	| 'ProductApprovalApprove'
	| 'ProductApprovalDecline'
	| 'ProductCreateBeneficiary'
	| 'ForkTicket'
	| 'InvoiceApprovalQueue'
	| 'InvoiceApprovalApprove'
	| 'InvoiceApprovalDecline'
	| 'InvoiceCreate'
	| 'InvoiceSchedulePayment';

export type TicketStatusEnum = 'Open' | 'Cancelled' | 'Closed';
export type TicketSlaLevelEnum = 'Good' | 'Warning' | 'Critical' | 'Overdue';

export type ButtonTypeEnum = 'Primary' | 'Default' | 'Dashed' | 'Text' | 'Link';
export type ButtonStyleEnum = 'Danger' | 'Ghost' | 'Default';
export type ButtonAlignmentEnum = 'Left' | 'Right';

export type CommunicationTypeEnum = 'Email' | 'Sms';
export type WorkflowRoleTypeEnum =
	| 'ViewOnly'
	| 'ListAndView'
	| 'ListViewAndProcess';
export type BulkUploadStatusEnum =
	| 'Pending'
	| 'Processing'
	| 'Completed'
	| 'Failed'
	| 'Rejected';
export type ReportFilterOperatorEnum =
	| 'Equals'
	| 'NotEquals'
	| 'GreaterThan'
	| 'LessThan'
	| 'GreaterThanOrEqual'
	| 'LessThanOrEqual';

export type TicketModeEnum = 'Claim' | 'Complaint' | 'Case';
export type TicketReportColumnValueTypeModeEnum =
	| 'Value'
	| 'When'
	| 'Who'
	| 'Captured';

export type BulkUploadLineStatusEnum =
	| 'Invalid'
	| 'Inserted'
	| 'Updated'
	| 'Failed';

export type TicketReportCellAlignmentEnum = 'Left' | 'Center' | 'Right';
export type TicketReportCellDataTypeEnum = 'Text' | 'Number' | 'Currency';
export type PolicyStatusEnum = 'Active' | 'Suspended' | 'Ended';
export type LiveStatusEnum = 'Unverified' | 'Deceased' | 'Living' | 'Error';

export type OtpChannelEnum = 'Email' | 'Sms';
export type NotificationStatusEnum =
	| 'Disabled'
	| 'Pending'
	| 'Busy'
	| 'Sent'
	| 'Failed';
export type ScreenGridBreakpointEnum = 'XS' | 'SM' | 'MD' | 'LG' | 'XL' | 'XXL';

// export type InsuranceProductContractPeriodEnum = 'Monthly';
// export type InsuranceProductFilterTypeEnum = 'EntryAgeFrom' | 'EntryAgeTo' | 'CurrentAgeFrom' | 'CurrentAgeTo';
// export type InsuranceProductDomainEnum = 'MainMember' | 'SpouseMember' | 'ChildMember' | 'StudentMember' | 'ExtendedFamilyMember';
export type LedgerTypeEnum =
	| 'PremiumDebit'
	| 'PremiumCredit'
	| 'BenefitPayment';
